import React, { useEffect, useState, lazy } from 'react';
import { motion } from 'framer-motion';
export function PriceBox() {
  const [viewers, setViewers] = useState(50);
  const [spots, setSpots] = useState(8);
  const [accessed, setAccessed] = useState(3250);
  useEffect(() => {
    const viewersInterval = setInterval(() => {
      setViewers(prev => Math.max(38, prev + (Math.random() > 0.5 ? 1 : -1)));
    }, 3000);
    const spotsInterval = setInterval(() => {
      setSpots(prev => prev > 2 ? prev - (Math.random() > 0.9 ? 1 : 0) : prev);
    }, 15000);
    const accessedInterval = setInterval(() => {
      setAccessed(prev => prev + (Math.random() > 0.7 ? 1 : 0));
    }, 10000);
    return () => {
      clearInterval(viewersInterval);
      clearInterval(spotsInterval);
      clearInterval(accessedInterval);
    };
  }, []);
  return <section id="pricing" className="py-6 px-4 bg-slate-50 relative z-10 overflow-hidden" data-id="element-210">
      <div className="max-w-4xl mx-auto" data-id="element-211">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#0a1a3a] rounded-2xl border-[3px] border-blue-400/70 relative overflow-hidden shadow-2xl" data-id="element-212">
          {/* Header Badge */}
          <div className="bg-blue-600 text-white font-extrabold py-3 px-4 text-center text-sm uppercase tracking-wider" data-id="element-213">
            OFERTA DE LANZAMIENTO EXCLUSIVA
          </div>

          <div className="p-6 md:p-8" data-id="element-214">
            {/* Title */}
            <h3 className="text-2xl md:text-3xl font-extrabold text-center uppercase tracking-wide mb-4 text-white" data-id="element-215">
              PACK DISEÑO MESAS Y ESPEJOS INFINITOS
            </h3>

            {/* Animated 5-in-1 Pack Image */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="mb-4 flex justify-center" data-id="element-216">
              <motion.img src="https://cdn.magicpatterns.com/uploads/gZ6ApJsv2Y3A3jAtKkHF86/imagen_1.jpg" alt="Pack Mesas y Espejos Infinitos" width={1200} height={1200} loading="lazy" decoding="async" className="w-full max-w-3xl h-auto rounded-2xl shadow-2xl pt-[15px] pb-[15px]" style={{
              willChange: 'transform'
            }} animate={{
              y: [0, -10, 0]
            }} transition={{
              duration: 3,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-217" />
            </motion.div>

            {/* Pricing */}
            <div className="text-center mb-1" data-id="element-218">
              <p className="text-sm text-gray-400 font-medium" data-id="element-219">
                Antes{' '}
                <span className="line-through text-[#E13756]" data-id="element-220">$49.990 ARS</span>
              </p>
            </div>

            <div className="text-center mb-4" data-id="element-221">
              <p className="md:text-6xl text-[56px] font-[800] text-[#03F003] mb-[10px]" data-id="element-222">
                $19.990{' '}
                <span className="text-lg font-normal text-[#FBFDFF]" data-id="element-223">ARS</span>
              </p>
              <p className="text-[#11F15E] text-sm font-bold uppercase tracking-widest mb-[30px]" data-id="element-224">
                🚀 RECUPERÁ TU INVERSIÓN CON TU PRIMERA VENTA
              </p>
            </div>

            {/* Cuotas sin interés badge */}
            <div className="flex justify-center mb-4" data-id="element-225">
              <motion.div className="relative overflow-hidden rounded-lg border-2 border-yellow-400 bg-gradient-to-r from-yellow-400/10 to-yellow-500/10 px-6 py-3 pt-[8px] pb-[8px] pl-[24px] pr-[24px]" data-id="element-226">
                <p className="text-center md:text-xl uppercase tracking-wide text-[16px] font-[700] font-[Montserrat,_sans-serif] text-[#50CA2F]" data-id="element-227">
                  💳 Hasta 3 cuotas sin interés
                </p>
                {/* Shimmer / shine effect sliding left to right every 3 seconds */}
                <motion.div className="absolute inset-0 pointer-events-none" style={{
                background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.25) 50%, transparent 100%)',
                width: '60%'
              }} animate={{
                x: ['-100%', '250%']
              }} transition={{
                duration: 1,
                repeat: Infinity,
                repeatDelay: 2,
                ease: 'easeInOut'
              }} data-id="element-228" />
              </motion.div>
            </div>

            {/* CTA Button */}
            <a href="https://www.sinfinstudio.online/cart/44075753078820:1" rel="noopener noreferrer" className="w-full text-gray-900 font-extrabold py-5 rounded-lg shadow-lg hover:shadow-xl transition-all flex mb-6 pt-[30px] pb-[30px] gap-[8px] items-center justify-center bg-[#0AF321] text-[16px]" data-id="element-229">
              SÍ, QUIERO MI PACK AHORA
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-230">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-231"></path>
              </svg>
            </a>

            {/* Scarcity and Social Proof Section (Redesigned to match image) */}
            <div className="mb-0 bg-[#f8f9fa] rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-232">
              {/* Top Header */}
              <div className="py-3 px-4 border-b border-gray-200 text-center" data-id="element-233">
                <p className="text-[13px] md:text-sm font-black text-[#1a1a1a] uppercase tracking-tight" data-id="element-234">
                  OFERTA VÁLIDA SOLO POR HOY:{' '}
                  <span className="text-[#d97706]" data-id="element-235">
                    {new Date().toLocaleDateString('es-AR', {
                    weekday: 'long',
                    day: 'numeric',
                    month: 'long'
                  }).toUpperCase()}
                  </span>
                </p>
              </div>

              {/* Middle Section (Two Columns) */}
              <div className="grid grid-cols-2 border-b border-gray-200" data-id="element-236">
                {/* Viewers Column */}
                <div className="p-4 flex items-center justify-center gap-3 border-r border-gray-200" data-id="element-237">
                  <div className="relative flex h-3 w-3" data-id="element-238">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#22c55e] opacity-75" data-id="element-239"></span>
                    <span className="relative inline-flex rounded-full h-3 w-3 bg-[#22c55e]" data-id="element-240"></span>
                  </div>
                  <div className="flex items-baseline gap-2" data-id="element-241">
                    <span className="text-4xl md:text-5xl font-black text-[#22c55e]" data-id="element-242">
                      {viewers}
                    </span>
                    <p className="text-[9px] md:text-[10px] font-black text-[#4b5563] leading-[1.1] uppercase" data-id="element-243">
                      PERSONAS
                      <br data-id="element-244" />
                      MIRANDO
                      <br data-id="element-245" />
                      EN ESTE
                      <br data-id="element-246" />
                      MOMENTO
                    </p>
                  </div>
                </div>

                {/* Spots Column */}
                <div className="p-4 flex items-center justify-center gap-3" data-id="element-247">
                  <div className="flex items-baseline gap-2" data-id="element-248">
                    <span className="text-4xl md:text-5xl font-black text-[#ef4444]" data-id="element-249">
                      {spots}
                    </span>
                    <p className="text-[9px] md:text-[10px] font-black text-[#4b5563] leading-[1.1] uppercase" data-id="element-250">
                      CUPOS
                      <br data-id="element-251" />
                      PROMOCIONALES
                      <br data-id="element-252" />
                      DISPONIBLES
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Payment Security Section */}
            <div className="bg-white rounded-2xl mt-8 mb-[18px] overflow-hidden" data-id="element-253">
              {/* Mercado Pago Block */}
              <div className="bg-[#E3F2FD]" data-id="element-254">
                <div className="flex justify-center" data-id="element-255">
                  <img src="https://cdn.magicpatterns.com/uploads/nRXxaZudtgrN28tXfRFyoX/medios_de_pagos.jpg" alt="Mercado Pago - Medios de Pago" width={896} height={256} loading="lazy" decoding="async" className="w-full h-auto" data-id="element-256" />
                </div>
              </div>

              {/* Total Accessed Section (Moved here) */}
              <div className="py-5 px-4 text-center bg-white border-y border-gray-100 pt-[20px] pb-[20px]" data-id="element-257">
                <p className="text-4xl md:text-6xl font-black text-[#22c55e] mb-1 tracking-tighter" data-id="element-258">
                  {'2672'}
                </p>
                <p className="text-xs md:text-sm font-black text-[#4b5563] uppercase tracking-wider" data-id="element-259">
                  PERSONAS YA ACCEDIERON
                </p>
              </div>

              {/* MercadoLíder Platinum */}
              <div className="p-4 border-t border-gray-200" data-id="element-260">
                <div className="flex items-center justify-center gap-2 mb-3" data-id="element-261">
                  <svg className="w-5 h-5 text-[#1E4620]" fill="currentColor" viewBox="0 0 20 20" data-id="element-262">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-263" />
                  </svg>
                  <h6 className="text-sm font-extrabold text-[#1E4620] uppercase" data-id="element-264">
                    MercadoLíder Platinum
                  </h6>
                </div>
                <p className="text-xs text-center text-[#388E3C] font-bold mb-4" data-id="element-265">
                  ¡Es uno de los mejores del sitio!
                </p>

                {/* Progress Bar */}
                <div className="h-2 bg-gradient-to-r from-red-500 via-yellow-400 to-green-500 rounded-full mb-4" data-id="element-266"></div>

                {/* Stats Grid */}
                <div className="grid grid-cols-3 gap-4 text-center" data-id="element-267">
                  <div data-id="element-268">
                    <p className="text-2xl font-extrabold text-gray-800" data-id="element-269">
                      2436
                    </p>
                    <p className="text-[10px] text-gray-600 leading-tight" data-id="element-270">
                      Ventas en los
                      <br data-id="element-271" />
                      últimos 60 días
                    </p>
                  </div>
                  <div data-id="element-272">
                    <div className="flex justify-center mb-1" data-id="element-273">
                      <div className="relative" data-id="element-274">
                        <svg className="w-8 h-8 text-gray-300" fill="currentColor" viewBox="0 0 20 20" data-id="element-275">
                          <path fillRule="evenodd" d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z" clipRule="evenodd" data-id="element-276" />
                        </svg>
                        <svg className="absolute -bottom-1 -right-1 w-4 h-4 text-[#388E3C] bg-white rounded-full" fill="currentColor" viewBox="0 0 20 20" data-id="element-277">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-278" />
                        </svg>
                      </div>
                    </div>
                    <p className="text-[10px] text-gray-600 leading-tight" data-id="element-279">
                      Brinda buena
                      <br data-id="element-280" />
                      atención
                    </p>
                  </div>
                  <div data-id="element-281">
                    <div className="flex justify-center mb-1" data-id="element-282">
                      <div className="relative" data-id="element-283">
                        <svg className="w-8 h-8 text-gray-300" fill="currentColor" viewBox="0 0 20 20" data-id="element-284">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" data-id="element-285" />
                        </svg>
                        <svg className="absolute -bottom-1 -right-1 w-4 h-4 text-[#388E3C] bg-white rounded-full" fill="currentColor" viewBox="0 0 20 20" data-id="element-286">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-287" />
                        </svg>
                      </div>
                    </div>
                    <p className="text-[10px] text-gray-600 leading-tight" data-id="element-288">
                      Despacha sus
                      <br data-id="element-289" />
                      productos a tiempo
                    </p>
                  </div>
                </div>
              </div>

              {/* Trust Badges Row - Moved to bottom */}
              <div className="flex flex-row justify-center items-center gap-6 mt-4 pt-4 border-t border-gray-200" data-id="element-290">
                {/* 7 Days Guarantee */}
                <div className="flex flex-col items-center" data-id="element-291">
                  <img src="https://cdn.magicpatterns.com/uploads/33L4RSMNtqLmpgL3G8P8RF/7_dias.jpg" alt="7 Días Garantía" width={96} height={96} loading="lazy" decoding="async" className="w-24 h-24 object-contain" data-id="element-292" />
                </div>

                {/* Secure Purchase */}
                <div className="flex items-center gap-3" data-id="element-293">
                  <div className="relative w-16 h-16" data-id="element-294">
                    <svg className="w-full h-full text-[#388E3C]" fill="currentColor" viewBox="0 0 20 20" data-id="element-295">
                      <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-296" />
                    </svg>
                    <svg className="absolute bottom-0 right-0 w-6 h-6 text-[#388E3C] bg-white rounded-full" fill="currentColor" viewBox="0 0 20 20" data-id="element-297">
                      <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" data-id="element-298" />
                    </svg>
                  </div>
                  <div data-id="element-299">
                    <p className="text-lg font-extrabold text-[#388E3C] uppercase leading-tight" data-id="element-300">
                      Compra Segura
                    </p>
                    <p className="text-xs font-bold text-[#388E3C]" data-id="element-301">
                      Compra 100% Segura
                    </p>
                  </div>
                </div>
              </div>

              {/* Small Lifetime Guarantee Integration */}
              <div className="px-4 pb-4 text-center" data-id="element-302">
                <p className="text-[11px] font-bold text-[#388E3C] flex items-center justify-center gap-1 uppercase tracking-tight" data-id="element-303">
                  <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20" data-id="element-304">
                    <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-305" />
                  </svg>
                  Garantía de por vida: te devolvemos el dinero si no estás
                  conforme
                </p>
              </div>
            </div>

            {/* Support Section */}
            <div className="mt-6 text-center" data-id="element-306">
              <p className="text-gray-400 text-sm mb-2" data-id="element-307">
                ¿Problemas con tu compra?
              </p>
              <a href="mailto:soportesinfinstudio@gmail.com" className="inline-flex items-center gap-2 text-blue-400 hover:text-blue-300 font-bold transition-colors group" data-id="element-308">
                <span data-id="element-309">Chateá con nosotros: soportesinfinstudio@gmail.com</span>
                <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-310">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-311"></path>
                </svg>
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}